<template>
    <div class="info_service">
        <pop :is-pop-show.sync = 'showOrder' @on-sure = 'closeOrder' :is-show-cancel="false" sureBtn_zh="确定同意" sureBtn_hk="確定同意">
            <div class="server-orderbox" slot="xw-pop-modal-body">
                <h3>{{$lang == 'zh' ? '「赏你赏他」推荐奖赏之条款及细则' : '「賞你賞他」推薦獎賞之條款及細則'}}:</h3>
                <div class="appyour-cont">
                    <p>
                        {{$lang == 'zh' ?
                         '1.「赏你赏他」推荐计划（「推荐计划」）只适用于「校园棒棒糖」计划–少糖级/半糖级/全糖级（12/24个月合约期适用），「推荐人」及「被推荐人」不能为同一人。'
                         : 
                         '1.「賞你賞他」推薦計劃（「推薦計劃」）只適用於「校園棒棒糖」計劃–少糖級/半糖級/全糖級（12/24個月合約期適用），「推薦人」及「被推薦人」不能為同一人。'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '2.「被推荐人」成功登记服务后，「推荐人」及「被推荐人」均可于合约期内第7至第12个月/第19至第24个月连续6个月，免费获赠每月1GB额外香港本地数据(即每人各获赠6GB)。'
                         : 
                         '2.「被推薦人」成功登記服務後，「推薦人」及「被推薦人」均可於合約期內第7至第12個月/第19至第24個月連續6個月，免費獲贈每月1GB額外香港本地數據(即每人各獲贈6GB)。'
                         }}
                        <br>
                        {{$lang == 'zh' ?
                         'i)「推荐人」及「被推荐人」免费获赠每月1GB之额外香港本地数据不可累积使用。由于「推荐人」可于推广期内获得最多5个推荐名额，如成功推荐5位「被推荐人」，則每月最多可享免费5GB之額外香港本地数据，'
                         : 
                         'i)「推薦人」及「被推薦人」免費獲贈每月1GB之額外香港本地數據不可累積使用。由於「推薦人」可於推廣期內獲得最多5個推薦名額，如成功推薦5位「被推薦人」，則每月最多可享免費5GB之額外香港本地數據，'
                         }}
                        <br>
                        {{$lang == 'zh' ?
                         'ii)若有任何剩余免费获赠之香港本地数据，将于当月底23:59自动取消，恕不另行通知。'
                         : 
                         'ii)若有任何剩餘免費獲贈之香港本地數據，將於當月底23:59自動取消，恕不另行通知。'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '3.「推荐人」必须为「校园棒棒糖」计划–少糖级/半糖级/全糖级之现有客户，「被推荐人」必须于推广期内通过开新号码/携号转台成功申请「校园棒棒糖」计划–少糖级/半糖级/全糖级(合约期12个月或24个月)及输入专属推荐码（「推荐码」）。'
                         : 
                         '3.「推薦人」必須為「校園棒棒糖」計劃–少糖級/半糖級/全糖級之現有客戶，「被推薦人」必須於推廣期內透過開新號碼/攜號轉台成功申請「校園棒棒糖」計劃–少糖級/半糖級/全糖級(合約期12個月或24個月)及輸入專屬推薦碼（「推薦碼」）。'
                         }}
                    </p>
                    <p>
                        {{$lang == 'zh' ?
                         '4.「推荐人」及「被推荐人」须符合之要求：'
                         : 
                         '4.「推薦人」及「被推薦人」須符合之要求：'
                         }}
                        <br> 
                        {{$lang == 'zh' ?
                         'i.已登记选用「校园棒棒糖」计划–少糖级/半糖级/全糖级及流动通讯服务计划仍然生效。'
                         : 
                         'i.已登記選用「校園棒棒糖」計劃–少糖級/半糖級/全糖級及流動通訊服務計劃仍然生效。'
                         }}
                        <br> 
                        {{$lang == 'zh' ?
                         'ii.「推荐人」必须为「中国电信CTExcel」现有客户（不适用于企业客户）。'
                         : 
                         'ii.「推薦人」必須為「中國電信CTExcel」現有客戶（不適用於企業客戶）。'
                         }}
                        <br> 
                        {{$lang == 'zh' ?
                         'iii. 「推荐人」必须于活动推广期内及于「被推荐人」申请及递交指定服务计划合约期，发送其专属推荐码（「推荐码」）予「被推荐人」。'
                         : 
                         'iii. 「推薦人」必須於活動推廣期內及於「被推薦人」申請及遞交指定服務計劃合約前，發送其專屬推薦碼（「推薦碼」）予「被推薦人」。'
                         }}
                        <br> 
                        {{$lang == 'zh' ?
                         'iv.「被推荐人」以香港身份证或有效之护照登记选用指定服务计划及签署期限合约。'
                         : 
                         'iv.「被推薦人」以香港身份證或有效之護照登記選用指定服務計劃及簽署期限合約。'
                         }}
                        <br> 
                        {{$lang == 'zh' ?
                         'v.「被推荐人」选用指定服务计划时必须输入由「推荐人」提供之有效「推荐码」。'
                         : 
                         'v.「被推薦人」選用指定服務計劃時必須輸入由「推薦人」提供之有效「推薦碼」。'
                         }}
                        <br> 
                        {{$lang == 'zh' ?
                         'vi.「被推荐人」之账户与服务计划生效日起计100日后仍维持生效及无拖欠任何账项记录。'
                         : 
                         'vi.「被推薦人」之賬戶於服務計劃生效日起計100日後仍維持生效及無拖欠任何賬項紀錄。'
                         }}
                        </p>
                    <p>
                        {{$lang == 'zh' ?
                         '5.「推广计划」推广期由2019年4月20日至2019年12月31日，包括首尾两天。'
                         : 
                         '5.「推薦計劃」推廣期由2019年4月20日至2019年12月31日，包括首尾兩天。'
                         }}
                         </p>
                    <p>
                        {{$lang == 'zh' ?
                         '6.「推荐人」可于推广期内获得最多5个推荐名额。「被推荐人」成功通过开新号码/携号转台选购指定月费时，有关推荐名额会即时被扣除。'
                         : 
                         '6.「推薦人」可於推廣期內獲得最多5個推薦名額。「被推薦人」成功透過開新號碼/攜號轉台選購指定月費時，有關推薦名額會即時被扣除。'
                         }}
                        </p> 
                    <p>
                        {{$lang == 'zh' ?
                         '7. 若「被推荐人」于合约期内终止合约，则无法继续享用此优惠，且需要按照合约上的规定赔偿有关款项；而「推荐人」不会受到任何影响。'
                         : 
                         '7. 若「被推薦人」於合约期内终止合约，則無法繼續享用此優惠，且需要按照合約上的規定賠償有關款項；而「推薦人」不會受到任何影響。'
                         }}
                        </p>
                    <p>
                        {{$lang == 'zh' ?
                         '8. 所有推荐奖赏不可转让他人、退回、转换或兑换为现金。'
                         : 
                         '8. 所有推薦獎賞不可轉讓他人、退回、轉換或兌換為現金。'
                         }}
                         </p>
                    <p>
                        {{$lang == 'zh' ?
                         '9.欲查询「推荐计划」之详情及优惠，请登入「中国电信CTExcel」官方网站www.ctexcel.com.hk之活动页面或致电24小时客户服务热线（+852）5749 9868。'
                         : 
                         '9.欲查詢「推薦計劃」之詳情及優惠，請登入「中國電信CTExcel」官方網站www.ctexcel.com.hk之活動頁面或致電24小時客戶服務熱線（+852）5749 9868。'
                         }}
                        </p>
                    <p>
                        {{$lang == 'zh' ?
                         '10.除特別注明外，上述月费优惠不可与其他推广优惠同时使用。'
                         : 
                         '10.除特別注明外，上述月費優惠不可與其他推廣優惠同時使用。'
                         }}
                        </p>
                    <p>
                        {{$lang == 'zh' ?
                         '11.如有合理怀疑「推荐人」以非法、诈骗或其他不良手法推荐上台，「中国电信CTExcel」将有权取消「推荐人」參加本「推荐计划」的资格。'
                         : 
                         '11.如有合理懷疑「推薦人」以非法、詐騙或其他不良手法推薦上台，「中國電信CTExcel」將有權取消「推薦人」參加本「推薦計劃」的資格。'
                         }}
                        </p>
                    <p>
                        {{$lang == 'zh' ?
                         '12.「中国电信CTExcel」保留随时更改、更新或终止所有优惠，以及修订所述任何条款及细则之权利，而不予事先通知。如有任何争议，「中国电信CTExcel」保留最终决定权。'
                         : 
                         '12.「中國電信CTExcel」保留隨時更改、更新或終止所有優惠，以及修訂所述任何條款及細則之權利，而不予事先通知。如有任何爭議，「中國電信CTExcel」保留最終決定權。'
                         }}
                        </p>
                </div>
            </div>
        </pop>
    </div>
</template>

<script>
    import pop from './pop.vue'
    export default {
        components: {
            pop
        },
        props: ['showOrder'],
        watch: {
            showOrder () {
                this.$emit('changeOrder',this.showOrder);
            }
        },
        data () {
            return {
            }
        },
        computed: {
            $lang () {
                return this.$i18n.locale == "zh" ? 'zh' : 'hk';
            }
        },
        methods: {
            closeOrder () {
                this.showOrder = false
            }
        }
    }
</script>

<style scoped lang="less">
.server-orderbox {
    width: 870px;
    padding: 0 35px 35px;
    h3 {
        text-align: center;
        font-size: 16px;
        padding: 10px 0 20px;
        border-bottom: 1px solid #eaeaea;
    }
    .appyour-cont {
        max-height: 60vh;
        padding-top: 20px;
        overflow-y: auto;
        p {
            font-size: 12px;
            line-height: 20px;
            color: #666;
        }
        
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/appYour.vue